import { useContext } from 'react';
import { CMSContext } from 'contexts';

export function useCMS() {
    const context = useContext(CMSContext);
    return context;
}
